<lib-action-button
    [kind]="ActionButtonKind.STROKED"
    largeButton
    [label]="label">
</lib-action-button>
